/**
 * Invokes the code to assign branding to the app
 */

import BrandingData from './BrandingData';
// adds branding class to an HTML element
document.documentElement.classList.add('gw-branding-' + BrandingData.BRANDING);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-branding-js/SetBranding.js
// module id = 1343
// module chunks = 0